(function () {

  'use strict';

  function pxOnelogin(IdpProviderService, IdpContextMenuMixin) {
    return {
      restrict: 'EA',
      scope: {
        tenant: '=',
        me: '='
      },
      templateUrl: 'app/components/authenticationSettings/oneLogin/oneLogin.template.html',
      link: function (scope) {
        scope.descriptor = IdpProviderService.descriptorByType('onelogin');
        scope.directories = IdpProviderService.directoriesFor(scope.tenant, 'onelogin');
        scope.redirectURI = IdpProviderService.redirectURIFor(scope.descriptor);
        scope.copyRedirectURI = function () {
          return IdpProviderService.copyRedirectURI(scope.descriptor);
        };
        IdpContextMenuMixin.attach(scope);
        IdpProviderService.attachListeners(scope, 'onelogin');
      }
    };
  }

  pxOnelogin.$inject = ['IdpProviderService', 'IdpContextMenuMixin'];

  angular
    .module('printix-admin')
    .directive('pxOnelogin', pxOnelogin);

})();
